























































































































import {Component} from 'vue-property-decorator';
import BaseLogin from '@/components/login/BaseLogin';
import SecurityAuthentication from '@/components/login/SecurityAuthentication.vue';
import DuplicateLoginCheck from '@/components/login/DuplicateLoginCheck.vue';
import {postAuthTokenValidation, PostAuthTokenRequest, PostAdminsPasswordEmailRequest, PostAuthLoginRequest, AuthToken} from 'supporter';
import { I18N_LOCALE, SESSION_INITIALIZE, SHOPBY_ACCESSTOKEN, SHOPBY_REFRESHTOKEN } from '@/const/words/cookie';
import {PopupRequestData} from '@/types';
import Cookies from 'js-cookie';
import {i18nObjectByKey} from '@/utils/i18n';
import { setSessionCookie, setToken } from '@/utils/dataUtils';
import {namespace} from 'vuex-class';
import { getCookie, deleteCookie } from '@/utils/cookieUtils';
import { stringify } from 'qs';
import { sanitizeRedirectPath } from '@/utils/sanitizeRedirectPath';
import { deleteAuthInfoToLogOut } from '@/utils/authUtils';
import { logSend } from '@/utils/logUtils';
const adminModule = namespace('admin');
const mallModule = namespace('mall');
const orderEnumsModule = namespace('orderEnums');

type SecondAuthData = {
  key: string;
  plan?: string;
  target: {
    email?: string;
    enableOtp: boolean;
    mobile?: string;
  };
  type?: string;
  types: string[];

  [key: string]: any;
}

@Component({
  components: {
    SecurityAuthentication,
    DuplicateLoginCheck
  }
})
export default class Login extends BaseLogin {
  @adminModule.Action('fetchMainMenus') private readonly fetchMainMenus: (refreshFlg: boolean) => Promise<void>;
  @mallModule.Action('fetchMalls') private readonly fetchMalls: (refreshFlg: boolean) => Promise<void>;

  @orderEnumsModule.Action('fetchOrderConfigsEnums')
  private readonly fetchOrderConfigsEnums!: () => Promise<void>;

  private isChangePwPopupOpen = false;
  private isIdRemember: boolean = false;
  private isIntegratedAccount: boolean = false;
  private isLocal: boolean = process.env.VUE_APP_NODE_ENV === 'local';
  private username: string = '';
  private password: string = '';
  private COOKIE_REMEMBERID = 'rememberId';
  private secondAuthData: SecondAuthData = {
    key: '',
    plan: '',
    target: {
      email: '',
      enableOtp: false,
      mobile: '',
    },
    type: '',
    types: [],
  };
  private isSecondAuthPopupOpen = false;
  private closePopup() {
    this.isSecondAuthPopupOpen = false;
  }

  private isDuplicateLoginCheckPopupOpen = false;
  private loginAdmin: any = null;
  private closeDuplicateLoginCheckPopup() {
    this.isDuplicateLoginCheckPopupOpen = false;
  }

  private completeSecondAuth(authToken: AuthToken) {
    setSessionCookie();
    alert('관리자 접속이 승인되었습니다.');
    this.closePopup();
    this.startDuplicateLoginCheck(authToken);
  }

  private mounted(): void {
    window.addEventListener('keydown', this.keydown);
    const rememberId = Cookies.get(this.COOKIE_REMEMBERID);
    if (rememberId != null) {
      this.username = rememberId;
      this.isIdRemember = true;
    }
  }
  keydown(event:KeyboardEvent){
    if(event.keyCode === 13){
      this.login();
    }
  }
  private changePasswordPopupRequestData: PopupRequestData = {
    id: 'changePasswordPopup',
    width: 480,
    title: 'VIEW_COMMON_CHANGEPASSWORD',
    hasConfirmBtn: true
  };

  private adminId: string = '';
  private adminName: string = '';
  private confirmChangePassword() {
    const request: PostAdminsPasswordEmailRequest = {
      data: {
        adminName: this.adminName,
        adminType: 'SERVICE',
        adminId: this.adminId,
        callbackUrl: window.location.protocol + '//' + location.host + '/profile/password-mail',
        adminEmail: ''
      }
    };
    if (!this.adminId) {
      alert(this.$t('VIEW_LOGIN_ADMIN_ID_PLACEHOLDE'));
      return;
    }
    if (!this.adminName) {
      alert(this.$t('VIEW_LOGIN_ADMIN_NAME_PLACEHOLDE'));
      return;
    }

    this.$api
      .postAdminsPasswordEmail(request)
      .then(() => {
        alert(this.$t('VIEW_LOGIN_ADMIN_SUCCESS_MESSAGE'));
        this.adminId = '';
        this.adminName = '';
      })
      .catch((error: any) => {
        if (error.data.code !== 'T0006') {
          alert(error.data.message || this.$t('VIEW_LOGIN_ADMIN_ERROR'));
        }
      });

    this.isChangePwPopupOpen = false;
  }
  created() {
    if (this.$route.query?.forceLogout === 'true') {
      deleteAuthInfoToLogOut();
    } else if (getCookie(SHOPBY_ACCESSTOKEN)) {
      this.$router.replace('/');
    }

    if(!getCookie(SHOPBY_ACCESSTOKEN) && !getCookie(SHOPBY_REFRESHTOKEN)){
      deleteCookie(SESSION_INITIALIZE);
    }

    this.changePasswordPopupRequestData = i18nObjectByKey(this, this.changePasswordPopupRequestData, 'title');
    if (this.$route.query?.accessToken) {
      setSessionCookie();
      this.startDuplicateLoginCheck(this.$route.query);
    }
  }

  private async login() {
    const authValidateRequest: PostAuthTokenRequest = {
      data: {
        id: this.username.trim(),
        password: this.password,
        adminType: 'SERVICE',
        grantType: this.isLocal && this.isIntegratedAccount ? 'COMMERCE_ACCOUNTS' : 'PASSWORD',
      }
    };
    const authLoginRequest: PostAuthLoginRequest = {
      data: {
        id: this.username.trim(),
        password: this.password,
        adminType: 'SERVICE',
      }
    };

    const validInfo = postAuthTokenValidation(authValidateRequest);
    if (validInfo.length) {
      (this.$refs[validInfo[0].field] as HTMLInputElement).focus();
      alert(this.$t(validInfo[0].message));
    } else {
      try {
        const authTokenResponse = await (
          this.isLocal && this.isIntegratedAccount
            ? this.$api.postAuthToken(authValidateRequest)
            : this.$api.postAuthLogin(authLoginRequest)
        );
        setSessionCookie();
        this.startDuplicateLoginCheck(authTokenResponse.data);
      } catch (error) {
        if(error.data.code === 'error.auth.AU1002') return;

        /**
         * POST /auth/token 외부접속차단 시의 에러 코드(AU1002).
         */
        if (error.data.code === 'error.auth.AU1001' || error.data.code === 'error.admin.A0003' || error.data.code === 'error.auth.E0010') {
          alert(error.data.message);
          if (error.data.code === 'error.auth.AU1001') {
            if (!['BASIC', 'PARTNER', 'PREMIUM', 'PRO', 'STANDARD'].includes(error.data.body?.plan)) {
              logSend(
                JSON.stringify({
                  type: 'two-factor-auth',
                  data: {
                    body: {
                      plan: error.data.body?.plan,
                      type: error.data.body?.type,
                    },
                    message: error.data.message,
                    method: error.data.method,
                    path: error.data.path,
                    status: error.data.status,
                    timestamp: error.data.timestamp,
                  },
                })
              );
            }
            this.secondAuthData = {
              ...this.secondAuthData,
              ...error.data.body,
            };

            this.isSecondAuthPopupOpen = true;
          }
          return;
        }

        if (error.data.code === 'error.auth.E0504') {
          this.integratedLogin();
          return;
        }

        alert(error.data.message);
      }
    }
  }

  private integratedLogin() {
    const {VUE_APP_COMMERCE_WEB_API,VUE_APP_PREMIUM_ADMIN_URL} = process.env;
    const integratedLoginUrl = `${VUE_APP_COMMERCE_WEB_API}/auth/oauth2/authorize${stringify({
      grant_type: 'authorization_code',
      response_type: 'code',
      client_id: 'oidc-client-shopby',
      scope: 'openid profile email phone',
      redirect_uri: `${VUE_APP_PREMIUM_ADMIN_URL}/oauth/redirect`,
      state: encodeURIComponent(sanitizeRedirectPath(this.$route.query?.redirectUrl?.toString())),
    }, {
      addQueryPrefix: true,
    })}`;
    process.env.VUE_APP_NODE_ENV !== 'production' && console.log(`${integratedLoginUrl} 로 이동합니다.`);
    window.location.href = integratedLoginUrl;
  }

  private async startDuplicateLoginCheck(authTokenData) {
    const {accessToken, refreshToken, planType, autoLogoutMin} = authTokenData;

    if (planType === 'BASIC' || planType === 'PRO') {
      alert(this.$t('ALERT_CHECK_PLAN_TYPE', { planType }));
      window.location.href = process.env.VUE_APP_PRO_ADMIN_URL;
      throw 'invalid plan type';
    }

    if (planType !== 'PREMIUM' && planType !== 'STANDARD') {
      alert(this.$t('VIEW_LOGIN_ADMIN_FAIL_MESSAGE'));
      throw 'invalid plan type';
    }

    this.loginAdmin = await setToken(accessToken, refreshToken, autoLogoutMin);
    if (this.isIdRemember) {
      Cookies.set(this.COOKIE_REMEMBERID, this.username);
    } else {
      Cookies.remove(this.COOKIE_REMEMBERID);
    }

    this.isDuplicateLoginCheckPopupOpen = true;
  }

  private async afterDuplicateLoginCheck() {
    this.isDuplicateLoginCheckPopupOpen = false;

    let i18nLocale = 'kr';
    const {data} = await this.$api.getAdminsService({params: {searchType: 'ADMIN_ID', keyword: this.loginAdmin.id}});
    const myAdmin = data.contents.find((tempAdmin) => tempAdmin.adminId === this.loginAdmin.id);
    if (myAdmin) {
      switch (myAdmin.language) {
        case 'CHINESE':
          i18nLocale = 'zh';
          break;
        case 'JAPANESE':
          i18nLocale = 'jp';
          break;
        case 'ENGLISH':
          i18nLocale = 'en';
          break;
        default:
          i18nLocale = 'kr';
          break;
      }
    }
    Cookies.set(I18N_LOCALE, i18nLocale);
    this.$i18n.locale = i18nLocale;

    Promise.all([
      // 로그인 후 주문 enums 세팅
      this.fetchOrderConfigsEnums(),
      // 로그인했을 때 메뉴와 몰정보 새로 받아 로컬스토리지에 저장하도록 처리
      this.fetchMainMenus(true),
      this.fetchMalls(true)
    ]).then(() => this.redirectAfterLogin());
  }

  beforeDestroy(){
    window.removeEventListener('keydown', this.keydown);
  }
}

